var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "product__section" }, [
    _c("h2", { staticClass: "product__section__heading" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "product__section__text",
      domProps: {
        innerHTML: _vm._s(
          _vm.show_full_content
            ? _vm.$sanitize(_vm.fullContent)
            : _vm.$sanitize(_vm.summary)
        )
      }
    }),
    _vm._v(" "),
    _vm.summary != _vm.fullContent
      ? _c(
          "button",
          {
            staticClass: "product__section__show-more show-more-button",
            class: { "show-more-button--close": _vm.show_full_content },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.toggle()
              }
            }
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.show_full_content
                    ? _vm.$modeoL10n.hide
                    : _vm.$modeoL10n.show_more
                ) +
                "\n  "
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f6eab1f", { render: render, staticRenderFns: staticRenderFns })
  }
}